
export default function RisingCabPayment() {
  return (
    <div className="payment-page">
      <div className="payment-card">
        <div className="header">
          <img src="/images/logo.jpg" alt="logo" className="logo" />

          <div>
            <h1 className="company-name text-white">Rising Cab Service</h1>
            <p className="subtitle text-white">
              Secure Online Payment
            </p>
          </div>
        </div>

        <div className="content d-grid">
          <div className="qr-section">
            <h2>Scan & Pay</h2>

            <div className="qr-box">
              <img
                src="/images/Payment-QR.jpeg"
                alt="QR"
                className="qr-image"
              />
            </div>
          </div>

          <div className="bank-card">
            <h2>Bank Details</h2>

            <div className="detail">
              <div className="label">Account Holder</div>
              <div className="value">
                Mr. Madhav Ankushrao Sangle
              </div>
            </div>

            <div className="detail">
              <div className="label">Account Number</div>
              <div className="value">
                80062030538
              </div>
            </div>

            <div className="detail">
              <div className="label">IFSC Code</div>
              <div className="value">
                MAHG0004249
              </div>
            </div>

            <div className="detail">
              <div className="label">Bank Name</div>
              <div className="value">
                Maharashtra Gramin Bank
              </div>
            </div>

            <div className="detail">
              <div className="label">Branch</div>
              <div className="value">
                Aundha Nagnath
              </div>
            </div>

            <div className="notice">
              After payment, share the screenshot
              with Rising Cab Service.
            </div>
          </div>
        </div>

       
      </div>
    </div>
  );
}